import { asyncLoad, getYMapsInstance } from './helpers';
import { yandexMapsUrl } from './constants';
import { ComponentsInitor } from './initor.js';

const instancesCollection = {};
let scriptLoadingPromise = null;
let updatedIsMobile = null; // its needed to have actual isMobile

const initYandexMap = (mapProps) => {
  const { mapId } = mapProps;
  const ymaps = getYMapsInstance();
  instancesCollection[mapId] = new ComponentsInitor({ ...mapProps, isMobile: updatedIsMobile });
  ymaps.ready(instancesCollection[mapId].Map);
};

const loadYandexMapScripts = ({ ...mapProps }) => {
  // ComponentsInitor needs to ymaps already added to window
  // then we just push all our props to it
  // === here we have definition for isMobile prop
  updatedIsMobile = mapProps.isMobile;
  // ===
  if (scriptLoadingPromise === null) {
    scriptLoadingPromise = new Promise((resolve) =>
      asyncLoad(`${yandexMapsUrl}`).then(() => {
        resolve();
        initYandexMap(mapProps);
      }),
    );
  } else {
    scriptLoadingPromise.then(() => {
      initYandexMap(mapProps);
    });
  }
};

const update = (points, prevIsMobile, isMobile, mapId) => {
  // in case if we have componentDidUpdate before script was loaded || map inited
  // we will update updatedIsMobile in controller scope, so in instances collection we will have
  // actual isMobile prop
  if (prevIsMobile !== isMobile) {
    updatedIsMobile = isMobile;
  }
  if (instancesCollection && instancesCollection[mapId]) {
    instancesCollection[mapId].updateMap(points, prevIsMobile, isMobile);
  }
  // to do remove
  /* setTimeout(() => {
    if (instancesCollection && instancesCollection[mapId]) {
      instancesCollection[mapId].updateMap(points, prevIsMobile, isMobile);
    }
  }, 2000); */
};

const unmount = (mapId) => {
  if (instancesCollection && instancesCollection[mapId]) {
    instancesCollection[mapId].destroyMap();
  }
};

export const map = {
  loadYandexMapScripts,
  update,
  unmount,
};
